import PageLayout from 'pages/CreateQuiz/PageLayout';
import PageProvider from 'pages/CreateQuiz/PageProvider';
import { Redirect, useLocation } from 'react-router-dom';

const CreateQuizPage = () => {
    const { state } = useLocation();

    if (!state?.quiz) return <Redirect to={'/quizzes'} />;

    return (
        <PageProvider>
            <PageLayout />
        </PageProvider>
    );
};

export default CreateQuizPage;
